var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 1.33398C5.0543 1.33398 2.6665 3.72178 2.6665 6.66732C2.6665 9.93592 4.51324 12.924 7.43677 14.3858L7.99984 14.6673L8.5629 14.3858C11.4864 12.924 13.3332 9.93592 13.3332 6.66732C13.3332 3.72178 10.9454 1.33398 7.99984 1.33398ZM7.99984 4.00065C8.73624 4.00065 9.33317 4.59758 9.33317 5.33398C9.33317 6.07038 8.73624 6.66732 7.99984 6.66732C7.26344 6.66732 6.6665 6.07038 6.6665 5.33398C6.6665 4.59758 7.26344 4.00065 7.99984 4.00065ZM9.61024 9.33398H6.38937C6.17297 9.33398 5.9981 9.12645 6.0651 8.92072C6.23904 8.38665 6.74104 8.00065 7.3331 8.00065H8.66644C9.25857 8.00065 9.7605 8.38658 9.93444 8.92072C10.0014 9.12645 9.82664 9.33398 9.61024 9.33398Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationUser);
export default __webpack_public_path__ + "static/media/location-user.6a61600979477029199cf6887db42bb0.svg";
export { ForwardRef as ReactComponent };